const prefix = 'Invariant failed';
export function invariant(condition, message) {
  if (!condition) {
    const error = new Error(message ? `${prefix}: ${message}` : prefix);
    Object.defineProperty(error, 'framesToPop', {
      value: 1,
      writable: true,
      configurable: true
    });
    throw error;
  }
}